import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import PropTypes from 'prop-types';
import { IoChatbubblesSharp, IoInformationCircleOutline, IoClipboardOutline } from 'react-icons/io5';

const PunchPointsModal = ({ show, onHide, value, onChange, onSave, canEdit }) => {
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['clean'],
    ],
  };

  // Helper to decode HTML if it was escaped (to handle "raw html" issues)
  const decodeHTML = (html) => {
    if (!html) return '';
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  };

  const displayValue = value && (value.includes('&lt;') || value.includes('&gt;')) ? decodeHTML(value) : value;

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      size="lg" 
      backdrop="static"
      centered
      className="premium-modal"
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold d-flex align-items-center text-primary">
          <IoChatbubblesSharp className="me-2" size={24} />
          Punch Points (Rework Comments)
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-3">
        {canEdit ? (
          <div className="edit-container">
            <p className="text-muted mb-3 d-flex align-items-center small">
              <IoInformationCircleOutline className="me-1" size={18} />
              Please enter the points to be addressed before sending this form to re-work.
            </p>
            <div className="quill-wrapper">
              <ReactQuill
                theme="snow"
                value={value || ''}
                onChange={onChange}
                modules={modules}
                placeholder="Type the rework points here..."
              />
            </div>
          </div>
        ) : (
          <div className="read-only-container p-4 rounded-3 bg-light border shadow-sm">
            {displayValue ? (
              <div
                className="quill-read-only-content ql-editor"
                style={{ padding: 0, minHeight: '150px' }}
                dangerouslySetInnerHTML={{ __html: displayValue }}
              />
            ) : (
              <div className="text-center py-5">
                <IoClipboardOutline className="text-muted mb-3 d-block mx-auto" size={64} opacity={0.5} />
                <p className="text-muted">No punch points have been added yet.</p>
              </div>
            )}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0">
        <Button variant="outline-secondary" onClick={onHide} className="px-4 rounded-pill">
          {canEdit ? 'Cancel' : 'Close'}
        </Button>
        {canEdit && (
          <Button 
            variant="primary" 
            onClick={onSave} 
            className="px-4 rounded-pill shadow-sm"
          >
             Submit to Rework
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

PunchPointsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
};

export default PunchPointsModal;
